<template lang='pug'>
//- 最新消息區塊
div(:class='$style[`cc-popbox-new-update`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-no-show`]')
    button(
      tabindex='0'
      aria-label='不再顯示'
      :class='$style[`cc-content-no-show-btn`]'
      @click='handleClickUpdateRead') 不再顯示

  div(v-if='loadData' :class='$style[`cc-content-main-wrap`]')
    ul(:class='$style[`cc-new-update-ul`]')
      li(v-for='items, index in loadData' :key='index' :class='$style[`cc-new-update-li`]')
        div(v-if='index === 0' :class='$style[`cc-new-update-main`]')
          header(:class='$style[`cc-new-update-header`]')
            div(:class='$style[`cc-new-update-header-date`]') {{ items.create_date }} 新消息
            div.font-bold(:class='$style[`cc-new-update-header-title`]') {{ items.title }}

          button(
            tabindex='0'
            :aria-label='items.title'
            :class='$style[`cc-new-update-btn`]'
            @click='handleClickEvent(items)')
            //- .btn-extra.font-medium(:class='$style[`cc-new-update-btn-tips`]') 了解更多
            figure(:class='$style[`cc-new-update-btn-bg`]')
              img(:src='`${SERVER_STATIC_URL}media/${items.photo_cover}`' width='100%')

        button(
          v-else
          tabindex='0' :aria-label='items.title'
          :class='[$style[`cc-new-update-main`], $style[`cc-new-update-main-normal`]]'
          @click='handleClickEvent(items)')
          header(:class='$style[`cc-new-update-header`]')
            div(:class='$style[`cc-new-update-header-date`]') {{ items.create_date }} 新消息
            div.font-bold(:class='$style[`cc-new-update-header-title`]') {{ items.title }}
          .btn-extra.font-medium(:class='$style[`cc-new-update-btn-tips`]') 了解更多

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// import { directive } from 'vue-awesome-swiper';
// import 'swiper/swiper-bundle.css';

import {
  putUpdateNewsRead,
} from '../../../js/restapi';

export default {
  props: {
    loadData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentIndex: 0,
      nextTick: 1,
    };
  },

  // created() {
  //   console.log('CHECK 1', this.loadData)
  // },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopLatestNewsStatus: 'global/POPLATEST_NEWS_STATUS',
    }),

    handleClosePopBox() {
      this.changePopLatestNewsStatus({
        active: false,
        list: [],
      });
    },

    readPwaTutorial() {
      this.changePopShowTutorialStatus({
        active: true,
        include: 'pwa',
      });
    },

    readTranslatorTutorial() {
      this.changePopShowTutorialStatus({
        active: true,
        include: 'translator',
      });
    },

    handleClickEvent(it) {
      if (it.prompt === 'event') {
        this.handleClickPopBox(it.link);
      } else if (it.prompt === 'redirect') {
        this.handleClickRouter(it.link);
      }
      this.handleClosePopBox();
    },

    handleClickPopBox(link) {
      switch (link) {
        case 'pwa':
          this.readPwaTutorial();
          break;
        case 'translator':
          this.readTranslatorTutorial();
          break;
        default:
          break;
      }
    },

    handleClickRouter(path) {
      const newPath = path.replace(/^.*\/\/[^\/]+/, '');
      this.$router.push({
        path: newPath,
      }).catch(() => true);
    },

    handleClickUpdateRead() {
      putUpdateNewsRead('', {
        auth_id: `${this.loginDjangoId}`,
      })
        .then((res) => {
          if (res.data === 'update ok') {
            this.handleClosePopBox();
            console.log('update read', this.currentIndex);
          }
        })
        .catch((err) => {
          console.log('error', err);
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popReadNews.scss';
</style>
